import { Button, MenuItem } from "@mui/material";
import styled from "styled-components";
import stringSimilarity from "string-similarity";
import DOMPurify from "dompurify";
import {
  collection,
  doc,
  getDocs,
  updateDoc,
  query,
} from "firebase/firestore/lite";
export const BEGIN_TEST = "BEGIN_TEST";
export const VOCABULARY = "Vocabulary";
export const VOCAB_TEST = "vocabtext";
export const READING_TEST = "reading";
export const LISTENING_TEST = "listening";
export const FINISH = "Finish";
export const REGION_GENERAL = "G";
export const REGION_INDIA = "IND";
export const REGION_DOMINIC_REPUBLICAN = "DR";
export const REGION_PHILLIPINES = "PHIL";
export const APT_TEST = "aptitude";
export const APTITUDE_TECHNICAL_TEST = "aptitude_technical";
export const COMPREHENSIVE_TEST = "comprehensive";
export const EMOTIONAL_INTELLIGENCE_TEST = "emotional_intelligence";
export const CALL_CENTER_KNOWLEDGE_TEST = "call_center_knowledge";
export const CUSTOMER_SERVICE_TEST = "customer_service";
export const SALES_TEST = "sales";
export const SALES_RETENTION_TEST = "sales_retention"
export const ATTENTION_TO_DETAIL_TEST = "attention";
export const INTEGRITY_TEST = "integrity";
export const ATTENDANCE_TEST = "attendance";
export const CEFR_READING_TEST = "cefr_reading";
export const CEFR_WRITING_TEST = "cefr_writing";
export const CEFR_LISTENING_TEST = "cefr_listening";
export const RETENTION_LISTENING_TEST = "retention_listening";
export const ALTICE_QUESTIONS_TEST = "altice_question";
export const SALES_AUDIO = "sales_audio";
export const CUSTOMER_SERVICE_AUDIO = "customer_service_audio";

export const TECH_SUPPORT = "tech_support"
export const TYPING_TEST = "typing_test"

export const getDeviceInfo = (step) => {
  const ua = navigator.userAgent || "";
  const platform = navigator.platform || "";

  // Parse browser
  let browser = "Unknown";
  let browserVersion = "";
  if (ua.includes("Edg/")) {
    browser = "Edge";
    browserVersion = ua.match(/Edg\/([\d.]+)/)?.[1] || "";
  } else if (ua.includes("OPR/") || ua.includes("Opera")) {
    browser = "Opera";
    browserVersion = ua.match(/(?:OPR|Opera)\/([\d.]+)/)?.[1] || "";
  } else if (ua.includes("SamsungBrowser")) {
    browser = "Samsung Internet";
    browserVersion = ua.match(/SamsungBrowser\/([\d.]+)/)?.[1] || "";
  } else if (ua.includes("Chrome") && !ua.includes("Edg")) {
    browser = "Chrome";
    browserVersion = ua.match(/Chrome\/([\d.]+)/)?.[1] || "";
  } else if (ua.includes("Safari") && !ua.includes("Chrome")) {
    browser = "Safari";
    browserVersion = ua.match(/Version\/([\d.]+)/)?.[1] || "";
  } else if (ua.includes("Firefox")) {
    browser = "Firefox";
    browserVersion = ua.match(/Firefox\/([\d.]+)/)?.[1] || "";
  }

  // Parse OS
  let os = "Unknown";
  if (/Windows/.test(ua)) os = "Windows";
  else if (/Mac OS X/.test(ua)) os = "macOS";
  else if (/Android/.test(ua)) os = "Android";
  else if (/iPhone|iPad|iPod/.test(ua)) os = "iOS";
  else if (/Linux/.test(ua)) os = "Linux";
  else if (/CrOS/.test(ua)) os = "ChromeOS";

  // Device type
  const isMobile = /Mobi|Android|iPhone|iPad|iPod/.test(ua);
  const isTablet = /iPad|Android(?!.*Mobile)/.test(ua) || (navigator.maxTouchPoints > 1 && /Macintosh/.test(ua));
  const deviceType = isTablet ? "tablet" : isMobile ? "mobile" : "desktop";

  // Media capabilities
  const hasGetUserMedia = !!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia);
  const hasMediaRecorder = typeof window.MediaRecorder !== "undefined";
  const supportedCodecs = [];
  if (hasMediaRecorder) {
    ["audio/webm", "audio/webm;codecs=opus", "audio/mp4", "audio/ogg;codecs=opus"].forEach((codec) => {
      try { if (MediaRecorder.isTypeSupported(codec)) supportedCodecs.push(codec); } catch (e) {}
    });
  }

  // Network
  const conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  const network = conn ? { type: conn.effectiveType || conn.type || "unknown", downlink: conn.downlink } : null;

  return {
    step,
    timestamp: new Date().toISOString(),
    userAgent: ua,
    browser,
    browserVersion,
    os,
    platform,
    deviceType,
    screen: { width: window.screen.width, height: window.screen.height },
    viewport: { width: window.innerWidth, height: window.innerHeight },
    hasGetUserMedia,
    hasMediaRecorder,
    supportedCodecs,
    network,
    language: navigator.language || "",
    cookiesEnabled: navigator.cookieEnabled,
    touchPoints: navigator.maxTouchPoints || 0,
  };
};

export const getSection = () => {
  return {
    'sections': [
        {'field': 'Vocabulary', 'score': 'vocabScore', 'order': '1', 'topic': 'Vocabulary', 'time': 'grammer_time'},
        {'field': 'aptitude', 'score': 'aptitude_score', 'order': '2', 'topic': 'aptitude', 'time': 'aptitude_time'},
        {'field': 'comprehensive', 'score': 'comprehensive_score', 'order': '3', 'topic': 'comprehensive', 'time': 'comprehensive_time'},
        {'field': 'emotional_intelligence', 'score': 'ei_score', 'order': '4', 'topic': 'emotional_intelligence', 'time': 'ei_time'},
        {'field': 'customer_service', 'score': 'cs_score', 'order': '5', 'topic': 'customer_service', 'time': 'cs_time'},
        {'field': 'sales', 'score': 'sales_score', 'order': '6', 'topic': 'sales', 'time': 'sales_time'},
        {'field': 'reading', 'score': 'reading_similarity', 'order': '7', 'topic': 'reading', 'time': 'recording_time'},
        {'field': 'listening', 'score': 'percentageScore', 'order': '8', 'topic': 'listening', 'time': 'listening_time'},
    ],
    'Description': 'Here goes lots of description for support',
    'Name': 'Support Specialist'
  }
}

export const getCurrentWeekYear = () => {
  const now = new Date();
  const year = now.getFullYear();
  const firstDayOfYear = new Date(year, 0, 1);
  const pastDaysOfYear = (now - firstDayOfYear) / 86400000; // milliseconds in a day
  const week = Math.ceil((pastDaysOfYear + firstDayOfYear.getDay() + 1) / 7);
  return { week, year };
};

export const navbarIconButton = ({ typography: { size }, breakpoints }) => ({
  px: 0.75,

  "& .material-icons, .material-icons-round": {
    fontSize: `${size.md} !important`,
  },

  "& .MuiTypography-root": {
    // display: "none",

    [breakpoints.up("sm")]: {
      display: "inline-block",
      lineHeight: 1.2,
      ml: 0.5,
    },
  },
});

export function convertToHTML(passages) {
  if (!passages) {
    return "";
  }

  let html = "";
  passages.split("\n").forEach((passage) => {
    const formattedPassage = passage
      .replace(/\t/g, "&nbsp;&nbsp;&nbsp;&nbsp;")
      .trim();
    html += `<p>${formattedPassage}</p>`;
  });

  const sanitizedHTML = DOMPurify.sanitize(html); // sanitize the HTML string

  return sanitizedHTML;
}

export const StyledLink = styled.span`
  text-decoration: underline;
  cursor: pointer;

  ${({ isSelected }) =>
    isSelected &&
    `
    color: #5569ED;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
    text-decoration-line: underline;
    text-decoration-style: solid;
    text-decoration-skip-ink: none;
    text-decoration-thickness: auto;
    text-underline-offset: auto;
    text-underline-position: from-font;
  `}
`;

export const CardListWrapper = styled.div`
  height: 80vh;
  overflow-y: scroll;
`;

export const AudioWrapper = styled("div")({
  display: "flex",
  flexDirection: "column",
  alignItems: "left",
  marginBottom: "16px",
  textAlign: "left",
  "& p": {
    marginTop: "0.5rem",
    marginBottom: "0.5rem",
    width: "100%",
  },
  "& audio": {
    flexGrow: 1,
    marginRight: "16px",
    width: "100%",
    // "&::-webkit-media-controls-enclosure": {
    //   display: "none",
    // },
    // "&::-webkit-media-controls-pause-button": {
    //   display: "none !important",
    // },
  },

  "& button": {
    flexGrow: 1,
    marginRight: "16px",
  },
  "@media (min-width: 768px)": {
    alignItems: "center",
    "& button": {
      maxWidth: "50%",
      width: "auto",
    },
    "& audio": {
      width: "99%",
    },
  },
});

export const QuestionContainer = styled.div`
  text-align: left;
  font-size: 1rem;
  border-top: 1px solid #ccc;
  & ul {
    list-style: none;
    padding: 0;
  }
`;

export const QuestionTitle = styled.h3`
  margin-bottom: 1rem;
  text-align: left;
  font-size: 1rem;
  font-weight: 600;
`;

export const QuestionHeader = styled.h2`
  margin-bottom: 1rem;
  text-align: left;
  font-size: 1rem;
  font-weight: 600;
`;

export const transcribeAudio = async (assessment) => {
  const formData = new FormData();


  // const storageRef = ref(getStorage());
  // const audioRef = ref(storageRef, `audios/${assessment.audioId}`);

  // const downloadURL = await fileRef.getDownloadURL();

  const response = await fetch(assessment.audioUrl);
  const blob = await response.blob();

  formData.append(
    "audio",
    blob
  );

  const fetchPromise = fetch(process.env.REACT_APP_SERVER_URL + "/transcribe", {
    method: "POST",
    body: formData,
  });

  const [fetchResult] = await Promise.all([fetchPromise]);

  const result = await fetchResult.text();
  const similarity =
    stringSimilarity.compareTwoStrings(result, assessment.passage) * 100;

    assessment.similarity = similarity
    assessment.transcribe = result
  // await updateDoc(doc(collection(db, "assessments"), assessment.uid), {
  //   reading_similarity: similarity.toFixed(2),
  //   transcribe: result,
  // });

  
};

